import { ReactElement } from 'react'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { InputLabel } from '@mui/material'
import { formatDate } from '../../utils/date-utils'

interface Props {
  label: string
  value?: Date
  onChange: (date: Date) => void
}

const DevelopusDatePicker = (props: Props): ReactElement => {
  const dateFormat = 'DD/MM/YYYY'
  const value = props.value != null ? formatDate(props.value) : null

  const onChange = (date: any) => {
    if (date != null) {
      props.onChange(date)
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <InputLabel
        sx={{
          display: 'inline-block',
          minWidth: '180px',
          verticalAlign: 'bottom',
        }}
      >
        {props.label}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={dayjs(value, dateFormat)}
          sx={{
            width: '205px',
            border: '0px',
            borderRadius: '0px',
            borderBottom: '1px',
          }}
          format={dateFormat}
          onChange={onChange}
        />
      </LocalizationProvider>
    </div>
  )
}

export default DevelopusDatePicker
